/**
 * TODO:
 * error image
 */

import Vue from 'vue'
import VueLazyload from 'vue-lazyload'
import noimage from '@/assets/noimage.png'
// Vue.use(VueLazyload)
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: noimage,
  // loading: '@/assets/noimage.png',
  attempt: 1,
  listenEvents: [ 'scroll' ]
})



// WEBPACK FOOTER //
// ./src/plugins/vue-lazyload.js